import List from './list/LabResearchSpecimenTypeListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})